enum UserRoutes {
  List = '/users',
  Add = '/users/add',
  Edit = '/users/edit/:id',
  Profile = '/users/me',
}

export default UserRoutes
